import { atom, PrimitiveAtom } from 'jotai'
import { atomsWithMutation } from 'jotai-tanstack-query'

import { currentEnv } from '@/env/vars.ts'
import { store } from '@/store'
import { IFeedback } from '@/types/gigiChat/Feedback'
import { POST } from '@/utils/fetch'

import { partialMessagesAtom, preventMessagesScroll } from './ChatAtom'

export const setFeedbackOnAtom = (feedback: IFeedback) => {
    const messages = store.get(partialMessagesAtom)
    const updatedMessages = messages.map((message) => {
        if (message.userPromptId === feedback.userPromptId) {
            message.feedback = { ...feedback }
        }
        return message
    })
    store.set(partialMessagesAtom, updatedMessages)
}

export const [, feedbackAtom] = atomsWithMutation(() => ({
    mutationFn: async ({ chatID, body }: { chatID: string; body: IFeedback }) => {
        await POST(
            `${currentEnv.features.isEnabled('gigiCore') ? currentEnv.coreChatUrl : currentEnv.chatUrl}/chats/${chatID}/feedback`,
            body,
        )
    },
}))

export const showFeedbackDrawerAtom: PrimitiveAtom<boolean> = atom<boolean>(false)

export const currentFeedbackAtom: PrimitiveAtom<IFeedback> = atom<IFeedback>({ type: 'neutral', comment: '', userPromptId: 0 })

export const updateFeedbackCallback = (feedback: IFeedback) => {
    store.set(currentFeedbackAtom, feedback)
    void preventMessagesScroll()
    setFeedbackOnAtom(feedback)
}
